import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteMasterSlice = createSlice({
  name: "DeleteMaster",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteMaster: (state, _) => {
      state.isLoading = true;
    },
    successDeleteMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteMaster: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteMaster,
  failureDeleteMaster,
  successDeleteMaster,
  clearDeleteMaster,
} = DeleteMasterSlice.actions;

export default DeleteMasterSlice.reducer;
